import * as React from 'react';
import { MembroModel, MonografiaModel } from '../../../Store';
import MembrosCard from './MembrosCard';
import DetalhesMonografiaCard from './DetalhesMonografiaCard';

interface IDetalhesProps {
  monografia: MonografiaModel;
  membros: MembroModel[];
}

const DetalhesAgendamentoCard: React.FC<IDetalhesProps> = ({ monografia, membros }: IDetalhesProps) => {
  return (
    <>
      <DetalhesMonografiaCard monografia={monografia} />
      <MembrosCard membros={membros} />
    </>
  );
};

export default DetalhesAgendamentoCard;